import {BehaviorSubject, Observable} from 'rxjs';
import {PlaceOrderRequestBody} from '@app/model/order/dcp-place-order-body.model';
import {Cart} from '@spartacus/cart/base/root';
import {PaymentState} from '@app/payment/services/store/payment-state';

export abstract class PaymentProviderService {
  /**
   * Flag, set to true if Continue to checkout review button is clicked
   * when iFrame is opened
   */
  private isNeedToShowCcErrorMessage$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  getErrorMessageStatus(): Observable<boolean> {
    return this.isNeedToShowCcErrorMessage$.asObservable();
  }

  setErrorMessageStatus(status: boolean): void {
    this.isNeedToShowCcErrorMessage$.next(status);
  }

  abstract openAddNewCreditCardComponent(currency: string): void;

  abstract closeAddNewCreditCardComponent(): void;

  abstract setPspMerchantId(cart: Cart): void;

  abstract isAddNewCreditCardComponentOpened(): Observable<boolean>;

  abstract startCcFlow(): void;

  abstract convertStateToPlaceOrderPayload(): Observable<PlaceOrderRequestBody>;

  abstract displayPaymentError(state: PaymentState): void;

  abstract saveAuthorizationErrors(state: PaymentState): void;
}
